import { BehaviorSubject } from "rxjs";

export class API {
  public static PAGE_SIZE = 10;

  public static NOTIFICATION = {
    // Listing: "notificationAuth/api/notificationmessages/v1.0/bycriteria",
    // NotificationType: "notificationAuth/api/refvalues/v1.0/1",
    // Servers: "notificationAuth/api/refvalues/v1.0/4",
    // MethodType: "notificationAuth/api/refvalues/v1.0/2",
    // AuthType: "notificationAuth/api/refvalues/v1.0/3",
    // Status: "notificationAuth/api/refvalues/v1.0/5",
    // Applications: "commonAuth/api/common/v1.0/refvalues?classIDs=455&langId=1",
    // EntityTypes: "commonAuth/api/common/v1.0/refvalues?classIDs=104&langId=1",
    // Details: "notificationAuth/api/notificationmessages/v1.0/:id/withlogs",
    // Dashboard: "notificationAuth/api/notificationmessages/v1.0/dashboard",

    Listing: "notification/api/notificationmessages/v1.0/bycriteria",
    NotificationType: "notification/api/refvalues/v1.0/1",
    Servers: "notification/api/refvalues/v1.0/4",
    MethodType: "notification/api/refvalues/v1.0/2",
    AuthType: "notification/api/refvalues/v1.0/3",
    Status: "notification/api/refvalues/v1.0/5",
    Applications: "common/api/common/v1.0/refvalues?classIDs=455&langId=1",
    EntityTypes: "common/api/common/v1.0/refvalues?classIDs=104&langId=1",
    Details: "notification/api/notificationmessages/v1.0/:id/withlogs",
    Dashboard: "notification/api/notificationmessages/v1.0/dashboard",
    ResendNotification: "notification/api/notification/v1.0/resend"
  };

  public static NOTIFICATION_SETTING = {
    // Listing: "notificationAuth/api/notificationsettings/v1.0",
    // Delete: "notificationAuth/api/notificationsettings/v1.0",
    // Add: "notificationAuth/api/notificationsettings/v1.0"

    Listing: "notification/api/notificationsettings/v1.0",
    Delete: "notification/api/notificationsettings/v1.0",
    Add: "notification/api/notificationsettings/v1.0"
  };

  public static NOTIFICATION_TRIGGER = {
    // Listing: "notificationAuth/api/notificationsettings/v1.0",
    // Delete: "notificationAuth/api/notificationsettings/v1.0",
    // Add: "notificationAuth/api/notificationsettings/v1.0"

    Listing: "notification/api/triggers/v1.0",
    Delete: "notification/api/triggers/v1.0",
    Add: "notification/api/notificationsettings/v1.0",
    DOMAINS: "common/api/common/v1.0/refvalues?classIDs=465",
    CATEGORIES: "notification/api/triggers/v1.0/getdomaincategories",
    TRIGGER:"notification/api/messagetemplaterule/v1.0/getbytriggerid",
    GETFIELDS:"notification/api/fields/v1.0/getbytrigger",
    FIELDS: 'notification/api/fields/v1.0',
    POST:'notification/api/messagetemplaterule/v1.0',
    TEMPLATE:"notification/api/templates/v1.0/getbytriggerid",
  };

  public static NOTIFICATION_DETAILS = {
    Listing: "notification/api/templates/v1.0",
    Delete: "notification/api/templatetranslation/v1.0",
    Add: "notification/api/templatetranslation/v1.0",
    Update: "notification/api/templatetranslation/v1.0"
  };

  public static NOTIFICATION_RULES = {
    // Listing: "notificationAuth/api/notificationrules/v1.0",
    // Delete: "notificationAuth/api/notificationrules/v1.0",
    // Add: "notificationAuth/api/notificationrules/v1.0"

    Listing: "notification/api/notificationrules/v1.0",
    Delete: "notification/api/notificationrules/v1.0",
    Add: "notification/api/notificationrules/v1.0"
  };

  public static QUEUE_STORAGE = {
    // Category: "commonAuth/api/common/v1.0/refvalues?classIds=756&langid=1",
    // RoutingKey: "queueAuth/api/queues/v1.0"

    Category: "common/api/common/v1.0/refvalues?classIds=756&langid=1",
    RoutingKey: "queue/api/queues/v1.0"
  };

  public static QUEUE_LISTING = {
    // Listing: "queueAuth/api/queues/v1.0",
    // Delete: "queueAuth/api/queues/v1.0",
    // Add: "queueAuth/api/queues/v1.0",

    Listing: "queue/api/queues/v1.0",
    Delete: "queue/api/queues/v1.0",
    Add: "queue/api/queues/v1.0",
  };

  public static DISPATCHING_RULES = {
    // Listing: "queueAuth/api/dispatchingrules/v1.0",
    // Delete: "queueAuth/api/dispatchingrules/v1.0",
    // Add: "queueAuth/api/dispatchingrules/v1.0"

    Listing: "queue/api/dispatchingrules/v1.0",
    Delete: "queue/api/dispatchingrules/v1.0",
    Add: "queue/api/dispatchingrules/v1.0"
  };

  public static QUEUE_DASHBOARD = {
    // Listing: "queueAuth/api/dashboard/v1.0",
    // ExecutingListing: "queueAuth/api/messages/v1.0",
    // Add: "queueAuth/api/dashboard/v1.0",
    // Status: "commonAuth/api/common/v1.0/refvalues?classIds=755&langid=1"

    Listing: "queue/api/dashboard/v1.0",
    ExecutingListing: "queue/api/messages/v1.0",
    Add: "queue/api/dashboard/v1.0",
    Status: "common/api/common/v1.0/refvalues?classIds=755&langid=1",
    RepublishMessage: "queue/api/publisher/v1.0/republish",
    MessageDetails : "queue/api/messages/v1.0",
    MessageLogDetails : "queue/api/messagelogs/v1.0/getbymessage"
  };

  public static WORKFLOW = {
    // Counters: "workflowAuth/api/v1.0/wrapper/dashboard",
    // Listing: "workflowAuth/api/v1.0/wrapper/runtime/tasks",
    // Scheduled_Jobs: "workflowAuth/management/timer-jobs"

    Counters: "workflow/api/v1.0/wrapper/dashboard",
    Listing: "workflow/api/v1.0/wrapper/runtime/tasks?includeProcessVariables=true",
    Scheduled_Jobs: "workflow/management/timer-jobs",
    TRASH_BIN_LISTING: "claim/api/tasklist/v1.0/userTrash?",
    ListingNew:"uiam/api/tasklist/v1.0/userTasks",
  };

  public static WORKFLOW_LISTING = {
    // Listing: "workflowAuth/repository/process-definitions",
    // Expandable_Listing: "workflowAuth/runtime/process-instances",
    // Popup_Image:
    //   "workflowAuth/repository/process-definitions/{processDefinitionId}/image",
    // Popup_Instance_Image:
    //   "workflowAuth/runtime/process-instances/{processInstanceId}/diagram",
    // Workflow_Variables:
    //   "workflowAuth/runtime/process-instances/{processInstanceId}/variables",
    // MAIN_TASKS: "workflowAuth/api/Tasks/v1.0/",

    Listing: "workflow/repository/process-definitions",
    Expandable_Listing: "workflow/runtime/process-instances",
    Popup_Image: "workflow/repository/process-definitions/{processDefinitionId}/image",
    Popup_Instance_Image: "workflow/runtime/process-instances/{processInstanceId}/diagram",
    Workflow_Variables: "workflow/runtime/process-instances/{processInstanceId}/variables",
    MAIN_TASKS: "workflow/api/Tasks/v1.0/",
  };

  public static TAKS_ROUTING_RULES = {
    // Listing: "workflowAuth/api/TaskRoutingRule/v1.0",
    // Delete: "workflowAuth/api/TaskRoutingRule/v1.0",
    // Add: "workflowAuth/api/TaskRoutingRule/v1.0",
    // Server: "commonAuth/api/common/v1.0/refvalues?classIds= 753&langid=1",
    // Service_Provider: "commonAuth/api/serviceprovider/v1.0/serviceprovider",
    // WorkflowId: "workflowAuth/repository/process-definitions?size=10000&stop=0",
    // TeamId: "usermanagement/api/team/v1.0/TeamByCriteria",
    // Start: "workflowAuth/api/TaskRoutingRule/v1.0/start",
    // Stop: "workflowAuth/api/TaskRoutingRule/v1.0/stop",

    Listing: "workflow/api/TaskRoutingRule/v1.0",
    Delete: "workflow/api/TaskRoutingRule/v1.0",
    Add: "workflow/api/TaskRoutingRule/v1.0",
    Reorder: "workflow/api/TaskRoutingRule/v1.0/list",
    Server: "common/api/common/v1.0/refvalues?classIds= 753&langid=1",
    Service_Provider: "common/api/serviceprovider/v1.0/serviceprovider",
    WorkflowId: "workflow/repository/process-definitions?latest=true&size=100",
    WorkflowNew: "workflow/api/WorkflowTypeController/v1.0/workflow?type=1",
    TeamId: "uiam/api/team/v1.0/TeamByCriteria",
    Start: "workflow/api/TaskRoutingRule/v1.0/start",
    Stop: "workflow/api/TaskRoutingRule/v1.0/stop",
    Status:"uiam/api/userlogging/v1.0/logout/3",
    LogIn:"uiam/api/userlogging/v1.0/login/3"
  
  };

  public static REPORT = {
    // Listing: "reportingAuth/api/reporting/v2.0/report",
    // Delete: "reportingAuth/api/reporting/v2.0/report",
    // Add: "reportingAuth/api/reporting/v2.0/report",
    // ReportType: "commonAuth/api/common/v1.0/refvalues?classIDs=758&langId=1",
    // Module: "commonAuth/api/common/v1.0/refvalues?classIDs=455&langId=1",
    // DeliveryType: "commonAuth/api/common/v1.0/refvalues?classIDs=759&langId=1",
    // QueuingOption: "commonAuth/api/common/v1.0/refvalues?classIDs=760&langId=1",
    // EncryptionType: "commonAuth/api/common/v1.0/refvalues?classIDs=761&langId=1",

    Listing: "reporting/api/reporting/v2.0/report",
    Delete: "reporting/api/reporting/v2.0/report",
    Add: "reporting/api/reporting/v2.0/report",
    ReportType: "common/api/common/v1.0/refvalues?classIDs=758&langId=1",
    Module: "common/api/common/v1.0/refvalues?classIDs=455&langId=1",
    DeliveryType: "common/api/common/v1.0/refvalues?classIDs=759&langId=1",
    QueuingOption: "common/api/common/v1.0/refvalues?classIDs=760&langId=1",
    EncryptionType: "common/api/common/v1.0/refvalues?classIDs=761&langId=1"
  };

  public static AUTOCOMPLETE = {
    // PROVIDER: "healthcareproviders/api/healthcareprovider/v1.0/providers?langid=1&providername=prov&providertype=24&fobid=1&networkid=1"

    PROVIDER: "healthcareprovider/api/healthcareprovider/v1.0/providers?langid=1&providername=prov&providertype=24&fobid=1&networkid=1"

  };

  public static LOGIN = {
    LOGIN: "userauth/login"
  };

  public static MENUITEMS = {
    MENUITEM: "menu/applicationmenu"
  };

  public static SEARCH_CLAIM = {
    // SEARCH: "claims/api/claim/v2.0/claimbycriterea"

    SEARCH: "claim/api/claim/v2.0/claimbycriterea"

  };

  public static SEARCH_USERS = {
    SEARCH: "uiam/api/accountinfo/v1.0/userList",
    ENTITY_TYPE: "uiam/api/privileges/v1.0/entityTypes",
    ENTITY: "uiam/api/accountinfo/v1.0/entitiesList/",
    USER_ROLES: "uiam/api/accountinfo/v1.0/userRoles",
    USER_IMAGE: "uiam/api/AccountInfo/v1.0/userImage",
    // ROLES: "usermanagement/api/Privileges/v1.0/roles",

    ROLES: "uiam/api/Privileges/v1.0/roles",
  };

  public static GET_USER = {
    SEARCH: 'uiam/api/accountinfo/v1.0/userInfo',
    DELETE: 'uiam/api/accountinfo/v1.0/userDelete',
    CHANGE_LOCK: 'uiam/api/accountinfo/v1.0/userLock/',
    UPDATE: 'uiam/api/accountinfo/v1.0/userEdit',
    // QUESTION: "commonAuth/api/common/v1.0/refvalues?classIds=562&langid=1",
    FORCE_PASSWORD_CHANGE: 'uiam/api/accountinfo/v1.0/userForcePwdChange/',
    CHANGE_PASSWORD: 'userauth/changePassword',
    GET_PASS_COMPLEXITY: 'userauth/getPasswordPolicy',
    UNLOCK_USER: 'uiam/api/accountinfo/v1.0/userUnlock/',
    UNDELETE: 'uiam/api/accountinfo/v1.0/userUndelete',
    SUSPEND: 'uiam/api/accountinfo/v1.0/userSuspend',
    ACTIVATE: 'uiam/api/accountinfo/v1.0/userActivate',
    MULTIPLE_DROPDOWN: 'uiam/api/accountinfo/v1.0/userEntityRoles',
    // DELETE_MULTIPLE: 'usermanagement/api/accountinfo/v1.0/deleteUserList',
    // RESET: 'usermanagement/api/accountinfo/v1.0/resetpassword/',

    DELETE_MULTIPLE: 'uiam/api/accountinfo/v1.0/deleteUserList',
    RESET: 'uiam/api/accountinfo/v1.0/resetpassword/',
    QUESTION: "common/api/common/v1.0/refvalues?classIds=562&langid=1",
    // get user info by username 
    USERINFO: 'uiam/api/accountinfo/v1.0/userinfobyusername/{username}',
    PRODUCER: "policy/api/policies/v1.0/producers/4"
  }

  public static ROLES = {
    ROLES: 'uiam/api/accountinfo/v1.0/userRolesList',
    UNASSIGN_ROLE: 'uiam/api/accountinfo/v1.0/userRolesUnassign',
    ASSIGN_ROLES: 'uiam/api/accountinfo/v1.0/userRolesAssign',
  }

  public static ENTITIES = {
    ENTITIES: 'uiam/api/accountinfo/v1.0/userEntitiesList',
    UNASSIGN_ENTITY: 'uiam/api/accountinfo/v1.0/userEntityUnassign',
    ASSIGN_ENTITY: 'uiam/api/accountinfo/v1.0/userEntityAssign'
  }

  public static ACTIVITY_USER = {
    FAILED_LOGINS: "uiam/api/userlogging/v1.0/userFailedLogins",
    LOGGEDIN_SESSIONS: "uiam/api/userlogging/v1.0/userSuccessLogins",
    SCREEN_ACTIVITES: "uiam/api/userlogging/v1.0/userScreenActivities",
    PASSWORD_HISTORY: "uiam/api/accountinfo/v1.0/userPasswordHistory",
    PREFERENCES: "uiam/api/accountinfo/v1.0/userPreference",
    // PASSWORD_POLICY: "usermanagement/api/privileges/v1.0/passwordComplexity"

    PASSWORD_POLICY: "uiam/api/privileges/v1.0/passwordComplexity"
  };

  public static COMMON = {
    // LANGUAGES: "commonAuth/api/common/v1.0/languages"

    LANGUAGES: "common/api/common/v1.0/languages",
    Classes: "common/api/common/v1.0/classes"
  };

  public static MOB = {
    // MOBDETAILS: "beneficiaries/api/beneficiary/v1.0/mob",
    // CLAIMEDAMOUNT: "beneficiaries/api/beneficiary/v1.0/mob/claimscount",
    // USEDAMOUNT: "beneficiaries/api/beneficiary/v1.0/mob/usedamount"
    MOBDETAILS: "beneficiary/api/beneficiary/v1.0/mob",
    CLAIMEDAMOUNT: "beneficiary/api/beneficiary/v1.0/mob/claimscount",
    USEDAMOUNT: "beneficiary/api/beneficiary/v1.0/mob/usedamount",
    PAYERMOBDETAILS: "product/api/mob/v1.0/payer"
  };

  public static PRIVILEGES = {
    // MODULES: 'usermanagement/api/privileges/v1.0/modules',
    // ENTITY_TYPES: 'usermanagement/api/privileges/v1.0/moduleEntityTypes',
    // ENTITY_TYPES_ROLES: 'usermanagement/api/privileges/v1.0/entityTypeRoles',
    // SCREEN_RIGHTS_LIST: 'usermanagement/api/privileges/v1.0/ScreenRightsList',
    // SCREEN_RIGHTS: 'usermanagement/api/privileges/v1.0/screenRights',
    // MODULE_LOCK_SETUP: 'usermanagement/api/privileges/v1.0/moduleUserLockSetup',
    // TERRITORY_LIST: 'commonAuth/api/common/v1.0/refvalues?classIds=145&langid=1',
    // PASSWORD_COMPLEXITY: "usermanagement/api/privileges/v1.0/passwordComplexity",
    // ROLE_MENU_ITEM_LIST: 'usermanagement/api/privileges/v1.0/roleMenuItemList',
    // ROLE_MENU_ITEM: 'usermanagement/api/privileges/v1.0/roleMenuItem',
    // ROLES_MANAGEMENT: "usermanagement/api/privileges/v1.0/roles",

    MODULES: 'uiam/api/privileges/v1.0/modules',
    ENTITY_TYPES: 'uiam/api/privileges/v1.0/moduleEntityTypes',
    ENTITY_TYPES_ROLES: 'uiam/api/privileges/v1.0/entityTypeRoles',
    SCREEN_RIGHTS_LIST: 'uiam/api/privileges/v1.0/ScreenRightsList',
    SCREEN_RIGHTS: 'uiam/api/privileges/v1.0/screenRights',
    MODULE_LOCK_SETUP: 'uiam/api/privileges/v1.0/moduleUserLockSetup',
    TERRITORY_LIST: 'common/api/common/v1.0/refvalues?classIds=145&langid=1',
    PASSWORD_COMPLEXITY: "uiam/api/privileges/v1.0/passwordComplexity",
    ROLE_MENU_ITEM_LIST: 'uiam/api/privileges/v1.0/roleMenuItemList',
    ROLE_MENU_ITEM: 'uiam/api/privileges/v1.0/roleMenuItem',
    ROLES_MANAGEMENT: "uiam/api/privileges/v1.0/roles",
    SCREEN_LIST:"uiam/api/user/v1.0/screenList",
    SCREEN_CUSTOM_PERMISSION_LIST:"uiam/api/userAuth/v1.0/screenCustomPermission",
    ROLE_SCREEN_CUSTOM_PERMISSION_LIST:"uiam/api/userAuth/v1.0/roleScreenCustomPermission",
    RANK_UPDATE:"uiam/api/privileges/v1.0/updateRank",
    DUPLICATE_MENU:"uiam/api/userAuth/v1.0/duplicateMenu",
    SCREEN_PERMISSION_LIST: 'uiam/api/privileges/v1.0/screenList',

  }

  public static TEMPLATE_LISTING = {
    // Listing: 'reportingAuth/api/reporting/v2.0/template',
    // Delete: 'reportingAuth/api/reporting/v2.0/template',
    // Add: 'reportingAuth/api/reporting/v2.0/template'

    Listing: 'reporting/api/reporting/v2.0/template',
    Delete: 'reporting/api/reporting/v2.0/template',
    Add: 'reporting/api/reporting/v2.0/template'
  }

  public static IMAGE_SETTING = {
    // Listing: 'reportingAuth/api/reporting/v1.0/image',
    // Delete: 'reportingAuth/api/reporting/v1.0/image',
    // Add: 'reportingAuth/api/reporting/v1.0/image'

    Listing: 'reporting/api/reporting/v1.0/image',
    Delete: 'reporting/api/reporting/v1.0/image',
    Add: 'reporting/api/reporting/v1.0/image'
  }

  public static TEMPLATE_SELECTION_RULES = {
    // Listing: 'reportingAuth/api/reporting/v1.0/templaterules',
    // Delete: 'reportingAuth/api/reporting/v1.0/templaterules',
    // Add: 'reportingAuth/api/reporting/v1.0/templaterules'

    Listing: 'reporting/api/reporting/v1.0/templaterules',
    Delete: 'reporting/api/reporting/v1.0/templaterules',
    Add: 'reporting/api/reporting/v1.0/templaterules',
    ListingId:'reporting/api/reporting/v1.0/templaterules/list',
  }


  public static CANVAS = {
    // Listing: "reportingAuth/api/reporting/v1.0/imagedetails",
    // DATA_FIELD: 'reportingAuth/api/reporting/v1.0/imagedatafieldsbytype/1',
    // DATE_FIELD: 'reportingAuth/api/reporting/v1.0/imagedatafieldsbytype/2',
    // IMG_FIELD: 'reportingAuth/api/reporting/v1.0/imagedatafieldsbytype/3',
    // Add: 'reportingAuth/api/reporting/v1.0/imagedetails'

    Listing: "reporting/api/reporting/v1.0/imagedetails",
    DATA_FIELD: 'reporting/api/reporting/v1.0/imagedatafieldsbytype/1',
    DATE_FIELD: 'reporting/api/reporting/v1.0/imagedatafieldsbytype/2',
    IMG_FIELD: 'reporting/api/reporting/v1.0/imagedatafieldsbytype/3',
    Add: 'reporting/api/reporting/v1.0/imagedetails'
  }

  public static ASOAPNUMBER = {
    // GETASOAPNUMBER: 'claims/api/claim/v2.0/generateAsoapNumber',

    GETASOAPNUMBER: 'claim/api/claim/v2.0/generateAsoapNumber',
  };

  public static CLAIMSHISTORY = {
    // GETCLAIMHISTORY: 'claims/api/claim/v2.0/MedicalFile',

    GETCLAIMHISTORY: 'claim/api/claim/v2.0/MedicalFile',
  };
  public static RESUBMITTED_CLAIMS = {
    // GETCLAIMHISTORY: 'claims/api/claim/v2.0/MedicalFile',

    GET: 'claim/api/claim/v2.0/getmedicalfileresubmission',
  };

  public static LEGACY_DATA = {
    Get: 'claim/api/legacyData/v1.0/getlegacydata',
  };

  public static PROVIDER_DETAILS = {
    // Get: 'healthcareprovider/api/healthcareprovider/v1.0/hprovider',
    Get: 'healthcareprovider/api/healthcareprovider/v1.0/hproviderdetail',
  };

  public static TRANSLATION_SENTENCES = {
    Listing: 'translation/api/sentences/v1.0',
    Delete: 'translation/api/sentences/v1.0',
    Add: 'translation/api/sentences/v1.0'
  };
  public static TRANSLATION_SENTENCE_DESC = {
    Listing: 'translation/api/sentencesdesc/v1.0',
    Delete: 'translation/api/sentencesdesc/v1.0',
    Add: 'translation/api/sentencesdesc/v1.0',
    BulkUpdate: 'translation/api/sentencesdesc/v1.0/bulk',
    GETDESCRIPTIONBYMODULE: 'translation/api/sentencesdesc/v1.0/getdescriptionbymodule',
    Customization: 'translation/api/sentencesdesc/v1.0'
  };

  public static TRANSLATION_SENTENCE_MANAGEMENT = {
    Listing: 'translation/api/translationmanagement/v1.0/bycriteria',
    Download: 'translation/api/translationmanagement/v1.0/downloadexcel',
    EditLov: 'translation/api/sysdesc/v1.0',
    EditSentence: 'translation/api/sentencesdesc/v1.0',
    BulkUpdate: 'translation/api/translationmanagement/v1.0/bulktranslate',
    EditLovUser: 'translation/api/userdesc/v1.0',
    GenerateLang: 'translation/api/translationmanagement/v1.0/generatemissingtranslations'
  };

  public static TRANSLATION_MENU_MANAGEMENT = {
    Listing: 'translation/api/menuitem/v1.0/applicationMenu',
    MenuUpdate: 'translation/api/menuitem/v1.0/applicationMenuUpdate'
  };

  public static PARTNER = {
    Listing: 'pio/api/partners/v1.0/partnersList',
    Edit: 'pio/api/partners/v1.0'
  };

  public static BUSINESS_TRANSACTION_SCHEDULE = {
    Listing: 'pio/api/schedulerexecution/v1.0/schedulerExecutionList',
  };
  public static BUSINESS_TRANSACTION_KEYS = {
    Listing: 'pio/api/businesstransactionkeysdetails/v1.0',
    Add: 'pio/api/businesstransactionkeysdetails/v1.0',
    Edit: 'pio/api/businesstransactionkeysdetails/v1.0',
    Delete: 'pio/api/businesstransactionkeysdetails/v1.0',
  };
  public static ADAPTER = {
    Listing: 'pio/api/adapter/v1.0',
    Edit: 'pio/api/adapter/v1.0',
    Add: 'pio/api/adapter/v1.0',
    Delete: 'pio/api/adapter/v1.0'
  };
  public static BUSINESS_TRANSACTION = {
    Listing: 'pio/api/transaction/v1.0',
    Edit: 'pio/api/transaction/v1.0',
    Add: 'pio/api/transaction/v1.0',
    Delete: 'pio/api/transaction/v1.0',
    AddNew: 'pio/api/transaction/v1.0/create',
    GET_TRANSACTION_TYPE_BY_PARTNER_TYPE: 'pio/api/transaction/v1.0/transactionTypesByPartnerTypes'
  };
  public static BUSINESS_TRANSACTION_PARAMS = {
    Listing: 'pio/api/transactionparam/v1.0',
    Edit: 'pio/api/transactionparam/v1.0',
    Add: 'pio/api/transactionparam/v1.0',
    Delete: 'pio/api/transactionparam/v1.0',
  };

  public static AUTHTOKEN_APPLIED_ENDPOINTS: any[] = [
    // 'usermanagement/api/privileges/v1.0/modules',
    // 'usermanagement/api/privileges/v1.0/moduleEntityTypes',
    // 'usermanagement/api/privileges/v1.0/entityTypeRoles',
    // 'usermanagement/api/privileges/v1.0/ScreenRightsList',
    // 'usermanagement/api/privileges/v1.0/screenRights',
    // 'usermanagement/api/privileges/v1.0/moduleUserLockSetup',
    // "usermanagement/api/privileges/v1.0/passwordComplexity",
    // 'usermanagement/api/privileges/v1.0/roleMenuItemList',
    // 'usermanagement/api/privileges/v1.0/roleMenuItem',
    // "usermanagement/api/privileges/v1.0/roles",
    // "usermanagement/api/team/v1.0/TeamByCriteria",
    // "usermanagement/api/User/v1.0/applicationMenu",
    // "usermanagement/api/accountinfo/v1.0/userList",
    // "usermanagement/api/Privileges/v1.0/roles",
    // "usermanagement/api/privileges/v1.0/entityTypes",
    // 'usermanagement/api/accountinfo/v1.0',
    // 'usermanagement/api/accountinfo/v1.0/deleteUser',
    // 'usermanagement/api/accountinfo/v1.0/deleteUserList',
    // 'usermanagement/api/accountinfo/v1.0/resetpassword/',
    // 'usermanagement/api/accountinfo/v1.0/changelockstatus/',
    // 'usermanagement/api/accountinfo/v1.0/UserInfo',
    // 'usermanagement/api/accountinfo/v1.0/forcePasswordChange/',
    // 'usermanagement/api/user/v1.0/changePassword',
    // 'usermanagement/api/accountinfo/v1.0/userRoles',
    // 'usermanagement/api/accountinfo/v1.0/userEntities',
    // "usermanagement/api/userlogging/v1.0/userLogFailedLogin",
    // "usermanagement/api/userlogging/v1.0/userLogSucessLogin",
    // "usermanagement/api/userlogging/v1.0/userLogActivity",
    // "usermanagement/api/accountinfo/v1.0/passwordHistory",
    // "usermanagement/api/accountinfo/v1.0/preference",
    // "usermanagement/api/privileges/v1.0/passwordComplexity"

    'uiam/api/privileges/v1.0/modules',
    'uiam/api/privileges/v1.0/moduleEntityTypes',
    'uiam/api/privileges/v1.0/entityTypeRoles',
    'uiam/api/privileges/v1.0/ScreenRightsList',
    'uiam/api/privileges/v1.0/screenRights',
    'uiam/api/privileges/v1.0/moduleUserLockSetup',
    "uiam/api/privileges/v1.0/passwordComplexity",
    'uiam/api/privileges/v1.0/roleMenuItemList',
    'uiam/api/privileges/v1.0/roleMenuItem',
    "uiam/api/privileges/v1.0/roles",
    "uiam/api/team/v1.0/TeamByCriteria",
    "uiam/api/User/v1.0/applicationMenu",
    "uiam/api/accountinfo/v1.0/userList",
    "uiam/api/Privileges/v1.0/roles",
    "uiam/api/privileges/v1.0/entityTypes",
    'uiam/api/accountinfo/v1.0',
    'uiam/api/accountinfo/v1.0/deleteUser',
    'uiam/api/accountinfo/v1.0/deleteUserList',
    'uiam/api/accountinfo/v1.0/resetpassword/',
    'uiam/api/accountinfo/v1.0/changelockstatus/',
    'uiam/api/accountinfo/v1.0/UserInfo',
    'uiam/api/accountinfo/v1.0/forcePasswordChange/',
    'uiam/api/user/v1.0/changePassword',
    'uiam/api/accountinfo/v1.0/userRoles',
    'uiam/api/accountinfo/v1.0/userEntities',
    "uiam/api/userlogging/v1.0/userLogFailedLogin",
    "uiam/api/userlogging/v1.0/userLogSucessLogin",
    "uiam/api/userlogging/v1.0/userLogActivity",
    "uiam/api/accountinfo/v1.0/passwordHistory",
    "uiam/api/accountinfo/v1.0/preference",
    "uiam/api/privileges/v1.0/passwordComplexity"
  ];

  public static DYNAMIC_REPORTS = {
    // Listing: 'reportingAuth/api/reporting/v1.0/dynamic/report',
    // Delete: 'reportingAuth/api/reporting/v1.0/dynamic/report',
    // Add: 'reportingAuth/api/reporting/v1.0/dynamic/report',
    // Dropdown: 'reportingAuth/api/reporting/v1.0/domain',
    // ShareWith: 'commonAuth/api/common/v1.0/refvalues?classIDs=480&langId=1',
    // Operator: 'reportingAuth/api/reporting/v1.0/operator',
    // Domains: 'reportingAuth/api/reporting/v1.0/domain',
    // Lov: 'reportingAuth/api/reporting/v1.0/lov'

    Listing: 'reporting/api/reporting/v1.0/dynamic/report',
    Delete: 'reporting/api/reporting/v1.0/dynamic/report',
    Add: 'reporting/api/reporting/v1.0/dynamic/report',
    Dropdown: 'reporting/api/reporting/v1.0/domain',
    ShareWith: 'common/api/common/v1.0/refvalues?classIDs=480&langId=1',
    Operator: 'reporting/api/reporting/v1.0/operator',
    Domains: 'reporting/api/reporting/v1.0/domain',
    Lov: 'reporting/api/reporting/v1.0/lov',
    Filter :'reporting/api/reporting/v1.0/report/filter',
    Aggrigation:'common/api/common/v1.0/refvalues?classIDs=478',
    Column:'reporting/api/reporting/v1.0/report/column',
    Sortby:'reporting/api/reporting/v1.0/report/sortby',
    Breakby:'reporting/api/reporting/v1.0/report/groupby',
    Copy:'reporting/api/reporting/v1.0/dynamic/report/clone'
  };

  public static PIO_CLASSES = {
    ADD: 'pio/api/datamodels/v1.0/class',
    Listing: 'pio/api/datamodels/v1.0/classList',
    ListingByTransactionId: 'pio/api/datamodels/v1.0/getClassListByTransactionId',
    Edit: 'pio/api/datamodels/v1.0/class',
    DELETE: 'pio/api/datamodels/v1.0/class'
  };
  public static PIO_CLASS_VALUES = {
    ADD: 'pio/api/datamodels/v1.0/classvalue',
    Listing: 'pio/api/datamodels/v1.0/',
    Edit: 'pio/api/datamodels/v1.0/classvalue',
    DELETE: 'pio/api/datamodels/v1.0/',
    UPLOAD: 'pio/api/datamodels/v1.0/uploadClassValues/',  //end point to upload excel for class value
    DOWNLOADXLTEMPFILE: 'pio/api/template/v1.0/pioTemplateDownload'
  };
  public static DATA_MODEL_FIELDS = {
    ADD: 'pio/api/datamodels/v1.0',
    GET_MODEL: 'pio/api/transaction/v1.0/senderreceiverdatamodel',
    Edit: 'pio/api/datamodels/v1.0/fields',
    Delete: 'pio/api/datamodels/v1.0/field',
    UPLOAD: 'pio/api/Mapping/v1.0/dataModelFieldsUpload/',
    DOWNLOADXLTEMPFILE: 'pio/api/Mapping/v1.0/dataModelFieldsDownload/'
  };
  public static DATA_MODELS = {
    Listing: 'pio/api/datamodels/v1.0/bypartner',
    Edit: 'pio/api/datamodels/v1.0',
    Add: 'pio/api/datamodels/v1.0',
    Delete: 'pio/api/datamodels/v1.0',
  };
  public static MAPPING = {
    Listing: 'pio/api/mapping/v1.0',
    Edit: 'pio/api/mapping/v1.0',
    Add: 'pio/api/mapping/v1.0',
    Delete: 'pio/api/mapping/v1.0'
  };
  public static MAPPING_VALUES = {
    Listing: 'pio/api/mapping/v1.0',
    Edit: 'pio/api/mapping/v1.0/mapValue',
    Add: 'pio/api/mapping/v1.0/mapValue',
    Delete: 'pio/api/mapping/v1.0',
    ClassValuesList: 'pio/api/datamodels/v1.0'
  };
  public static MAPPING_RULES = {
    Listing: 'pio/api/mapping/v1.0',
    Edit: 'pio/api/mapping/v1.0/mapRule',
    Add: 'pio/api/mapping/v1.0/mapRule',
    Delete: 'pio/api/mapping/v1.0'
  };
  public static HL7_SIMPLIFIER = {
    Listing: 'pio/api/simplifiedjsonconfiguration/v1.0/getByTransaction',
    Edit: 'pio/api/simplifiedjsonconfiguration/v1.0',
    Add: 'pio/api/simplifiedjsonconfiguration/v1.0',
    Delete: 'pio/api/simplifiedjsonconfiguration/v1.0'
  };
  public static HL7_Conditions = {
    Listing: 'pio/api/simplifiedjsonconfiguration/v1.0/getRulesByConfigurationId',
    Add: 'pio/api/simplifiedjsonconfiguration/v1.0/insertRule',
    Edit: 'pio/api/simplifiedjsonconfiguration/v1.0/updateRule',
    Delete: 'pio/api/simplifiedjsonconfiguration/v1.0/deleteRule'
  };
  public static REFRESH_TOKEN = {
    REFRESH: 'userauth/refreshToken'
  };
  public static LOGOUT = {
    LOGOUT: "userauth/logout"
  };
  public static RESET_PASSWORD = {
    SEND_RECOVERY_LINK: "basicNoAuth/v1.0/resetPasswordRequest",
    CHECK_RESET_KEY: "basicNoAuth/v1.0/checkResetKey",
    RESET_PASS: "basicNoAuth/v1.0/resetPassword",
    GET_PASS_COMPLEXITY: "basicNoAuth/v1.0/getPasswordPolicy",
  };

  public static ADD_USER = {
    ADD_NEW_USER: "uiam/api/accountInfo/v1.0/userAdd",
    GET_BRANCHES: "uiam/api/AccountInfo/v1.0/branchesList/",
    // LANGAUGES: 'commonAuth/api/common/v1.0/languages',
    // ACTIVE_TERRITORIALS: 'commonAuth/api/common/v1.0/territorials',
    // ACTIVE_COUNTRIES: 'commonAuth/api/common/v1.0/allcountries',
    CREATE_USER: "healthcareprovideronboarding/v1.0/hprovideronboarding",

    LANGAUGES: 'common/api/common/v1.0/languages',
    ACTIVE_TERRITORIALS: 'common/api/common/v1.0/territorials',
    ACTIVE_COUNTRIES: 'common/api/common/v1.0/allcountries',
  }



  public static GET_LANGUAGES = "language/GetDetails";
  public static GET_PROVIDER_TYPE = "Classification/GetDetails";
  public static GET_STATUS_LIST = "Provider/GetProviderStatus";
  public static GET_PROVIDER_DETAILS = "MPM/GetProviderDetails";
  public static SAVE_PROVIDER_DETAILS = "Provider/ProviderDetails";
  public static GET_PROVIDER_LIST = "Provider/GetProviderList";
  public static GET_CURRENCY = "Currency/GetDetails";
  public static GET_REGION = "Region/GetDetails";
  public static GET_EFFECTIVE_DATES = "MPM/GetEffectiveDate";

  public static QUESTIONNAIRE = {
    GET_QUESTIONNAIRE: "Questionaire/GetDetails",
    SAVE_QUESTIONNAIRE: "Questionaire/SaveDetails",
    GET_ATTACHMENT_BY_ID: "Questionaire/GetQuestionnaireAttachmentById",
    DELETE_ATTACHMENT_BY_ID: "Questionaire/DeleteQuestioinnaireAttachmentById"
  }
  public static DELETE_PROVIDER_IMAGE = "Provider/DeleteImagesById";
  public static GET_STAGE = "Provider/GetStageDetails";

  public static TRANSLATION = {
    GET_ALL_LANGUAGES_LOGGED_OUT: 'commonbasic/api/common/v1.0/languages?used=true&validated=true',
    GET_ALL_LANGUAGES_LOGGED_IN: 'common/api/common/v1.0/languages?used=true&validated=true',
    MISSING_TRANSLATION_LOGGED_OUT: 'translationbasic/v1.0/addmissingsentences',
    MISSING_TRANSLATION_LOGGED_IN: 'translation/api/sentences/v1.0/addmissingsentences'
  }
  public static HEALTHCARE={
    Search:'healthcareprovider/api/healthcareprovider/v1.0/providers?langid=1'
  }
  public static UPLOADPROCELIST_FOBLIST={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/fobclasses'
  }
  public static GET_SERVICEPROVIDERLIST={
    URL:'common/api/serviceprovider/v1.0/serviceprovider'
  }
  public static GET_PRIORITYPAYERLIST={
    URL:'common/api/common/v1.0/countryschemes?countryId='
  }
  public static DELETE_AGREEMENT={
    url:'healthcareprovider/api/healthcareprovider/v1.0/hpagreement'
  }
  public static DELETE_PROFESSIONALACCOUNTINFO={
    url:'healthcareprovider/api/healthcareprovider/v1.0/hpprofessionalaccountinfo'
  }
  public static AGREEMENTDOCUMENTLOGS={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hpagreement/document/logs/'
  }
  public static AGREEMENTCUSTOMIZATIONDELETE={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/notusedclaimssetup"
  }
  public static AGREEMENTCUSTOMIZATIONDATA={
    add:'healthcareprovider/api/healthcareprovider/v1.0/notusedclaimssetup'
  }
  public static GET_CONTRACTEDPARTIES={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/contractedparties/'
  }
  public static NEW_AGREEMENT={
    add:'healthcareprovider/api/healthcareprovider/v1.0/hpagreement'
  }
  public static DOWNLOADDOCUMENTAGREEMENT={
    add:'healthcareprovider/api/healthcareprovider/v1.0/hpagreement/document/download'
  }

  public static DELETEDOCUMENTAGREEMENT={
    add:'healthcareprovider/api/healthcareprovider/v1.0/hpagreement/document/remove/'
  }
  public static REQUIREDAPI_AGREEMENTDETAILS={
    URL:'common/api/bank/v1.0/bankbranches'
  }
  public static AGREEMENTDOCUMENTUPLOAD={
    add:'healthcareprovider/api/healthcareprovider/v1.0/hpagreement/document/upload'
  }
  public static AGREEMENTCUSTOMIZATIONlIST={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/notusedclaimssetup/'
  }
  public static LOADAGREEMENTSCHEDULE={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hpschedules?'
  }
  public static GET_AGREEMENTDETAILS={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hpagreements/'
  }
  public static GETAGREEMENTDOCUMENT={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hpagreement/document/"
  }
  public static LOADAGREEMENTNETWORKSHOW={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hpagreement/"
  }
  public static LOADAGREEMENTNETWORKLOG={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hpagreement/networks/logs/"
  }
  public static VALIDATEAGREEMENTAPI={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hpagreement/validate"
  }
  public static AUTHORIZEAGREEMENT={
    url:"uiam/api/user/v1.0/userentities/"
  }
  public static AGREEMENTCUSTOMIZATIONPAYERLIST={
    URL:'payer/api/payers/v1.0/'
  }
  public static GET_PARENTENTITY_NEWHEALTHCAREPROVIDER={
    URL:'common/api/common/v1.0/entities?langId=1'
  }
  public static HEALTHCAREPROVIDER_SERVICES={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/services'
  }
  public static HEALTHCAREPROVIDER_ACCOUNT_INFOS={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hpprofessionalaccountinfo'
  }
  public static HEALTHCAREPROVIDER_ACCOUNT_INFOS_DETAIL={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hpprofessionalaccountinfo/'
  }
  public static HEALTHCAREPROVIDER_SERVICES_LOGS={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/servicelogs'
  }
  public static NETWORKPROFESSIONALLIST={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/professionals?countryId='
  }
  public static GET_FOBList={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/fobclasses?providerType='
  }
  public static  GETSCHEDULELIST={  
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hpschedules?"
  }
  public static  SCHEDULESERVICEPRICELIST={  
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/serviceprices?langId=1&"
  }
  public static SAVE_UPDATED_PRICElIST={
    ADD:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/service/itemspricelist"
  }
  public static SECHEDULESERVICELIST={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/services?countryId="
  }
  
  public static SCHEDULECURRENCYLIST={
    URL:"common/api/common/v1.0/refvalues?classIDs=36&langId=1"
  }
  public static SERVICEPRICESCHEDULE={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hpstandards/"
  }
  public static NEWAGREEMENTFOBLIST={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/fobclasses?langid=1&providerType='
  }
  public static SERVICEPRICESPECIFICSCHEDULE={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hpspecstandards/"
  }
  public static SERVICEPRICEINGMODE={
    URL:"common/api/common/v1.0/refvalues?langId=1"
  }
  public static SERVICEPRICEDITEMLIST={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/service/itemspricelist"
  }
  public static SERVICEPRICEDETAIL={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/servicepricesdetail?langId=1"
  }
  public static SERVICEPRICEVALIDATE={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/serviceprice/validate"
  }
  public static SAVESCHEDULE={
    ADD:"healthcareprovider/api/healthcareprovider/v1.0/hpschedule"
  }
  public static SAVEHEALTHCAREPROVIDERPROF_ACCOUNTINFO={
    ADD:"healthcareprovider/api/healthcareprovider/v1.0/hpprofessionalaccountinfo"
  }
  public static SAVEHEALTHCAREPROVIDERPROF_ACCOUNTINFO_VALIDATE={
    ADD:"healthcareprovider/api/healthcareprovider/v1.0/hpprofessionalaccountinfo/validate"
  }
  public static SCHEDULESERVICEPRICELISTUPLOAD={
    ADD:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/prices/upload/validate"
  }
  public static SAVESERVICEPRICEDATA={
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/servicepricesdetail"
  }
  public static SAVE_PRICEDITEM_PROFESSIONALDATA={
    ADD:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/service/profitemspricelist?specificflag="
  }
  public static  SCHEDULEDETAIL={  
    URL:"healthcareprovider/api/healthcareprovider/v1.0/hpschedules?"
  }
  public static GET_EPRESCRIPTION_CLAIMSPORTAL_NEWHEALTHCAREPROVIDER={
    URL:'common/api/common/v1.0/claimsengineandportal?langId=1'
  }
  public static GETONEPROVIDERDETAIL={
    Search:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/'
  
  }
  public static GET_NEWHEALTHCAREPROVIDER_DETAILS={
    REQUIRE_DETAILS:'common/api/common/v1.0/refvalues?langId=1&'
  }
  public static NETWORK_PROF_TYPE={
    URL:'common/api/common/v1.0/professionalspecialities'
  }
  public static NETWORK_PROFESSIONALDETAILS={
    URL:'healthcareprovider/api/professional/v1.0/professional/'
  }
  public static PRICEDITEMSEARCHPROFESSIONAL={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/professionals?professionalType='
  }

  public static PROFITITEMPRICELIST={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/service/profitemspricelist?countryId='
  }

  public static SERVICEPROFFESIONALTYPE={
    url:"common/api/common/v1.0/professionalspecialities?langId=1"
  }
  public static DELETE_SERVICEPRICE={
    DELETE:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/servicepricesdetail"
  }
  
  public static GET_LANGUAGE_NEWHEALTHCAREPROVIDER={
    REQUIRE_DETAILS:'common/api/common/v1.0/languages?used=true&validated=true&langId=1'
  }
  public static GET_COUNTRY_NEWHEALTHCAREPROVIDER={
    COUNTRY_LIST:'common/api/common/v1.0/addressdetails'
  }
  public static DOWNLOADLOGOFORHEALTHCAREPROVIDER={
    url:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/downloadlogo'
  }
  public static SCHEDULELISTFORSERVICEPRICE={
    url:'healthcareprovider/api/healthcareprovider/v1.0/hpschedules?'
  }

  public static SERVICELISTFORSERVICEPRICE={
    url:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/serviceprices/copy/fillService?countryId='
  }
  public static SAVESERVICEPRICESCOPY={
    add:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/serviceprices/copy"
  }
  public static SAVESTATUSSERVICEPRICE  ={
    add:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/serviceprices/thpStdItemStatus/save"
  }
  public static PROVIDERIMAGEUPLOAD={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/uploadlogo"
  }
  public static SEARCHSTATUSSERVICEPRICE  ={
    url:"healthcareprovider/api/healthcareprovider/v1.0/hprovider/schedule/serviceprices/thpStdItemStatus?serviceID="
  }
  public static ADDNEWHEALTHCAREPROVIDER={
    add:'healthcareprovider/api/healthcareprovider/v1.0/hprovider'
  }
  public static HEALTHCAREPROVIDER_SAVESERVICES={
    add:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/services'
  }
  public static SAVEPROFFESIONALDETAILS={
    add:'healthcareprovider/api/professional/v1.0/professional'
  }
  public static UPLOADLOGOFORHEALTHCAREPROVIDER={
    url:'healthcareprovider/api/healthcareprovider/v1.0/hprovider/uploadlogo'
  }
  public static GET_UserGuideList={
    URL:'fileservice/api/fileservice/v1.0/download'
  }
  public static SEARCH_ACCOUNTNAME={
    URL:'paymentorder/api/paymentorder/v1.0/accounts?'
  }
  public static ISHEALTHCAREEXTERNALREF_REQUIRED={
    URL:'common/api/common/v1.0/territorysetting?terrid='
  }
  public static USERS_UNDER_SPROVIDER={
    URL:'api/serviceprovider/v1.0/serviceprovider/user/'
  }
  public static LICENSENUMBERVERIFY={
    url:'common/api/common/v1.0/password/check'
  }
  public static HEALTHCAREPROVIDER_HPProfessionalsAccountInfos={
    URL:'healthcareprovider/api/healthcareprovider/v1.0/hpprofessionalaccountinfo?countryid='
  }
  public static TEAM = {
    Listing: 'uiam/api/team/v1.0/teamList',
    Add: 'uiam/api/team/v1.0',
    Update: 'uiam/api/team/v1.0',
    Delete: 'uiam/api/team/v1.0',
    GET_USERS_IN_TEAM: 'uiam/api/user/v1.0/usersinteam',
    GET_SERVICE_PROVIDER: 'uiam/api/team/v1.0/serviceproviders',
    ASSIGN_USER: 'uiam/api/user/v1.0/usersinteam',
    DELETE_ASSIGN_USER: 'uiam/api/user/v1.0/usersinteam',
    COUNTRIES: 'common/api/common/v1.0/allcountries',
    PROVIDER_TYPE: 'common/api/common/v1.0/refvalues',
    PROVIDER: 'healthcareprovider/api/healthcareprovider/v1.0/providers',
    PAYER: 'payer/api/payers/v1.0/15',
    MASTERCONTRACT: 'policy/api/policies/v1.0',
    NEWPAYER: 'payer/api/payers/v1.0',
    //MASTERCONTRACT : 'payer/api/payers/v1.0/15',

    FOB: 'common/api/common/v1.0/refvalues',
    GET_DIST: 'uiam/api/team/v1.0/teamdistribution',
    ADD_DIST: 'uiam/api/team/v1.0/teamdistribution',
    UPDATE_DIST: 'uiam/api/team/v1.0/teamdistribution',
    DELETE_DIST: 'uiam/api/team/v1.0/teamdistribution',
    UPDATE_MIN_MAX: 'uiam/api/user/v1.0/usercapacity',
    SERVER: 'inbound/api/fax/v1.0/getfaxservers',

  }

  public static TEAM_ROUTING = {
    Listing: 'uiam/api/team/v1.0/teamrouting',
    Add: 'uiam/api/team/v1.0/teamrouting',
    Update: 'uiam/api/team/v1.0/teamrouting',
    Delete: 'uiam/api/team/v1.0/teamrouting',
    Bulk: 'uiam/api/team/v1.0/teamrouting/list',
  }

  public static SUMMARY_VIEW = {
    Listing: 'workflow/api/Tasks/v1.0',
  }

  public static TASK_LIST = {
    USERLIST: 'uiam/api/user/v1.0/usersinteam/userstoforward',
    USERS_IN_TEAM : 'uiam/api/user/v1.0/usersinteam',
    USERS_BY_SERVICE_PROVIDER: 'uiam/api/user/v1.0/usersinteam/userstoforward',
    ASSIGN_USER: 'workflow/api/TaskRoutingRule/v1.0/assignTask',
    DELETE_FMS: 'claim/api/tasklist/v1.0/task?',
    MASTERCONTRACT: 'policy/api/policies/v1.0',
    STATUS: 'uiam/api/userlogging/v1.0/userStatus/3'
  }

  public static BANKING = {
    GET_DETAILS: "Provider/GetBanking",
    SET_DETAILS: "Provider/SetBanking",
    GET_BRANCHES: "common/api/bank/v1.0/bankbranches"
  }

  public static GET_ADDRESSES = "common/api/common/v1.0/addresses";

  public static NOTIFICATION_TEMPLATES = {
    GEALLTEMP: 'notification/api/templates/v1.0',
    DELET_TEMP: 'notification/api/templates/v1.0',
    ADD_TEMP: 'notification/api/templates/v1.0',
    EDIT_TEMP: 'notification/api/templates/v1.0',
    GEALLTEMPFIELDS: 'notification/api/fields/v1.0/getbytemplate',
    FIELDS: 'notification/api/fields/v1.0',
  }

  public static TEMPLATES = {
    DOWNLOAD_NOMENCLATURE_TEMPLATE: "Provider/DownloadNomenclatureTemplate",
    UPLOAD_NOMENCLATURE: "MPM/UploadNomenclature",
    PHYSICIANS_DOWNLOAD: "Doctors/GetDoctorsList",
    PHYSICIANS_UPLOAD: "/Doctors/SetDoctorsList",

  }

  public static GET_UPLOADED_NOMENCLATURE = "MPM/GetUploadedNomenclature";

  public static VALIDATE_NOMENCLATURE = "MPM/ValidateNomenclature";

  public static PROVIDER_CLASSIFICATION = "Classification/Master";

  public static ADJUDICATE = "caremanager/api/claims/adjudicate/v2/care";

  public static SET_NOT_USED = "claim/api/claim/v1.0/validateandmarkclaimnotused?";

  public static EVENTS = {
    EVENTLISTING: 'notification/api/triggerRules/v1.0/eventlisting',
    GET_ALL_TRIGGER: 'notification/api/triggerRules/v1.0',
    GET_TRIGGER_BY_ID: 'notification/api/triggerRules/v1.0',
    ADD_TRIGGER: 'notification/api/triggerRules/v1.0',
    EDIT_TRIGGER: 'notification/api/triggerRules/v1.0',
    DELETE_TRIGGER: 'notification/api/triggerRules/v1.0',

    GET_TRIGGER_RULES: 'notification/api/triggerruledetails/v1.0',
    SAVE_TRIGGER_RULES: 'notification/api/triggerruledetails/v1.0/addBulk',

    DESTINATION_DROPDOWN: 'common/api/common/v1.0/refvalues?classIDs=446&langId=1',
    NOTIFICATION_TYPE: 'common/api/common/v1.0/refvalues?classIDs=749&langId=1',

    GET_ALL_DETAILS: 'notification/api/triggerruledetails/v1.0/allbyruleid',

    ATTACHMENT: 'common/api/common/v1.0/refvalues?classIDs=723&langId=1'

  }

  public static GET_SERVICE_ITEMS = "healthcareprovider/api/healthcareprovider/v1.0/serviceitems?";
  public static GET_STANDARD_ITEMS = "healthcareprovider/api/healthcareprovider/v1.0/standarditems?";
  public static GET_ACTIVE_ITEMS = "healthcareprovider/api/healthcareprovider/v1.0/hprovider/activeitemcoeff?";
  public static GET_SERVICE_ITEM_ADDITIONAL_DETAILS = "healthcareprovider/api/healthcareprovider/v1.0/serviceitems/agreedprice?";

  public static PIO_MONITORING = {
    PARTNERS_LIST: 'pio/api/partners/v1.0/partnersList',
    BUSINESS_TRANSACTIONS_BY_PARTNER: 'pio/api/partners/v1.0/',
    GET_LIST_OF_TRANSACTIONS_EXECUTIONS: 'pio/api/businesstransactionfiles/v1.0/filesList/',
    GET_DETAILS_OF_AN_EXECUTION: 'pio/api/businesstransactionfiles/v1.0/fileDetails/',
    GET_ALL_STATUS: 'common/api/common/v1.0/refvalues?classIDs=773&langId=1',
    RETRY_TRANSACTION: 'pio/api/businesstransactionfiles/v1.0/retryTransaction/',
    GET_ADVANCED_SEARCH_KEYS: 'pio/api/businesstransactionkeysdetails/v1.0/',
    DOWNLOAD_FILE: 'pio/api/businesstransactionfiles/v1.0/fileDownload',
    RETRY_File: 'pio/api/businesstransactionfiles/v1.0/retryFile/',
    TRANSACTION_RETRY_OPTION: 'pio/api/transaction/v1.0/',
    TRANSACTION_LIST_BY_ACTION_TYPE: 'pio/api/businesstransactionfiles/v1.0/transactionsDetailsList/',
    SET_TRANSACTION_AS_FIXED: 'pio/api/transaction/v1.0/setTransactionAsFixed'
  }

  public static PIO_DASHBOARD = {
    GET_TRANSACTION_TYPE_SUMMARY: 'pio/api/dashboard/v1.0/transactionTypeSummary',
    GET_TRANSACTIONS_SUMMARY_BY_STATUS: 'pio/api/dashboard/v1.0/transactionsSummaryByStatus',
    GET_TRANSACTION_SUMMARY_BY_ERROR_TYPE: 'pio/api/dashboard/v1.0/transactionsSummaryByErrorType'
  }

  public static BOILER_PLATE = {
    GET_TRANSACTION_SUMMARY_BY_PARTNER_TYPE: 'pio/api/dashboard/v1.0/transactionsSummaryByPartnerType',
    GET_TRANSACTION_DETAILS_BY_STATUS: 'pio/api/dashboard/v1.0/transactionDetailsByStatus',
    GET_TRANSACTION_STATUS_SUMMARY_BY_PARTNER_TYPE: 'pio/api/dashboard/v1.0/transactionsStatusSummaryByPartnerType',
    GET_TRANSACTION_SUMMARY_BY_CRITERIA: 'pio/api/dashboard/v1.0/transactionsummerByCreateria',
    GET_LEVEL_2_SUMMARY_LIST: 'pio/api/dashboard/v1.0/level2SummaryList',
    GET_TRANSACTION_List_BY_PARTNER_TYPE: 'pio/api/dashboard/v1.0/transactionsListByPartnerTypes', 
    GET_LEVEL_3_SUMMARY_LIST: 'pio/api/dashboard/v1.0/level3SummeryList'
  }

  public static HEART_BEAT = {
    GET_LATEST_INCOMING_OUTGOING_REQUEST: 'pio/api/businesstransactionfiles/v1.0/transactionsListByActionType',
  }

  public static PIO_EDI = {
    INCOMING_ENVELOP_SCREEN: 'pio/api/envelope/v1.0/incomingEnvelopesList/',
    OUTGOING_ENVELOP_SCREEN: 'pio/api/envelope/v1.0/outgoingEnvelopesList',
    INCOMING_ENVELOP_TRANSACTIONS_SCREEN: 'pio/api/envelope/v1.0/incomingEnvelopeTransactions/',
    OUTGOING_ENVELOP_TRANSACTIONS_SCREEN: 'pio/api/envelope/v1.0/outgoingEnvelopeTransactions',
    OUTGOING_ERROR_TRANSACTIONS_SCREEN: 'pio/api/envelope/v1.0/OutgoingErrorTransactions',
    DOWNLOAD_ENVELOP_FILE: 'pio/api/envelope/v1.0/FetchEnvelopeXML',
    DOWNLOAD_XML_FILE: 'pio/api/envelope/v1.0/FetchXML'
  }
  public static CLAIMDOCS = {
    UPLOAD_DOC: 'claim/api/claimAttachments/v1.0/fileattachment',
    UPDATE_NOT_SHARE_ENTITY: 'claim/api/claimAttachments/v1.0/fileattachmentrestriction',
    DOWNLOAD: 'fileservice/api/fileservice/v1.0/download',
    DELETEDOC: 'claim/api/claim/v2.0/comments',
    VIEWPDF: 'claim/api/claim/v2.0/viewpdf'
  }

  public static APPOINTMENTS = {
    GET_APPOINTMENTS: "claim/api/appointment/v1.0/get",
    VALIDITY_DATE: "claim/api/claim/v1.0/getvaliditydate",
    DELETE_APPOINTMENT: "claim/api/appointment/v1.0/delete",
    BENEFICIARY_COVERAGE: "beneficiary/api/beneficiary/v1.0/beneficiarycoverages",
    SAVE: "claim/api/appointment/v1.0/add",
    SEND_REQUEST: "claim/api/appointment/v1.0/sendrequest",
    CONFIRM_APPOINTMENT: "claim/api/appointment/v1.0/confirm"
  }

  public static NOTES = {
    SAVE: 'claim/api/notes/v1.0'
  }

  public static BATCH = {
    SEARCH_BY_ID: 'claim/api/batch/v1.0/',
    PROCESS_ACTION: 'claim/api/batch/v1.0/',
    SEARCH_BATCH: 'claim/api/batch/v1.0/batches/',
    DELETE_BATCH: "claim/api/batch/v1.0",
    FINISH_BATCH: "claim/api/batch/v1.0/finishclaims",
  }

  public static DOCUMENTVIEWER = {
    DOWNLOAD: 'fileservice/api/fileservice/v1.0/download',
    EXTRACT: 'ocr/Extract',
    MASKING:'ocr/maskImage'
  }

  public static GET_AGREEMENT = "caremanager/api/provider/agreement/v1.0";

  public static CHECK_EOC = "claim/api/claim/v2.0/eocexists";
  public static REFERRAL_SOURCE = "healthcareprovider/api/healthcareprovider/v1.0/hprovider";
  public static GET_CURRENCY_DATA = "common/api/common/v2.0/currencies?";

  public static AUTHORIZE_CHECK = "claim/api/claim/v2.0/generate/form";

  public static PRINTAUTHORIZECHECK = 'claim/api/claim/v2.0/printauthorization';
  public static SEND_LAST_DOCUMENT = 'claim/api/claim/v2.0/sendlastdocument';
  public static GET_RECEIVED_DOCS = "claim/api/claim/v2.0/receivedfax";

  public static DELETE_CLAIM = 'claim/api/claim/v2.0/claim';

  public static TEST_RESULTS = 'claim/api/ebilling/v1.0/itemtestresults';

  public static SHOW_HDF = 'claim/api/claim/v2.0/showhdf';

  public static FWD_TO_INBOX = 'claim/api/tasklist/v1.0/forwardtomaininbox';

  public static ROUTE_TO_OFFICER = 'claim/api/tasklist/v1.0/forwardmultipleclaims';

  public static RESUBMISSION = "claim/api/claim/v2.0/getmedicalfileresubmission";

  public static SERVICE_PROVIDER_ROUTER_POPUP = "uiam/api/accountinfo/v1.0/userServiceProviders";

  public static INSERT_UPDATE_APPROVAL_ITEMS = "claim/api/items/v2.0/overrideitem";

  public static XRATE = "common/api/common/v1.0/rate?";

  public static testBehObj = new BehaviorSubject(null);

  public static GET_MONOGRAPH_DATA = "care/api/fdb/v1.0/monograph";
  public static autoTriggerFlag = new BehaviorSubject<Object>({ triggeredFunctionName: '', flag: false });
  public static CHECK_TERRITORY_SETTING = "common/api/common/v1.0/territorysetting";
  public static GET_ALL_TEST_RESULTS = "claim/api/ebilling/v1.0/testresults";
  // public static GET_PRINCIPLE_DROPDOWN = "policy/api/policies/v1.0/v1/familymembers";
  public static GET_PRINCIPLE_DROPDOWN = "policy/api/policies/v1.0/familymembers";
  public static CHECK_AUTHORITY_PIN = "uiam/api/user/v1.0/changePasswordComplexityCheck";
  public static GET_PROVIDER_LICENCE_NUMBERS = "healthcareprovider/api/healthcareprovider/v1.0/contractedparties";

  public static E_REFERRAL = {
    GET: 'claim/api/claim/v2.0/geterefferal?'
  }

  public static E_REFERRAL_LOG = {
    GET: 'claim/api/claim/v1.0/erefferallogs?'
  }

  public static GET_BENEFICIARY_CARD_DATA = "reporting/report/v1/card";
  public static SET_NOTIFICATION_RULES = "claim/api/notification/v1.0/rulesSendNotification/";
  public static PAYER_ADDRESS: 'payer/api/payers/v1.0/address/';

  //endpoints for ems report
  public static GET_EMS_REPORT_DATA: '/api/fax/v1.0/getfaxinfo/';
  public static FORWARD_TO_MAIN_INBOX: '/api/fax/v1.0/forwardtomaininbox/';
  public static FORWARD_BY_MAIL: '/api/notification/v1.0/Send';
  public static AUDIT_TRAIL_WITH_FAX_ID: 'inbound/api/fax/v1.0/viewaudittrail';
  public static DELETE_WITH_FAX_ID: '/api/fax/v1.0/delete/';
  public static MOVE_TO_INBOX: '/api/fax/v1.0/delete/';
  public static DUPLICATE_FAX: '/api/fax/v1.0/duplicate/';
  public static GET_TYPE: '/inbound/api/faxtype/6/""/0';
  public static GET_FAX_STATUS: '/inbound/api/faxstatus';

  public static SEARCH_PROVIDER: 'healthcareprovider/api/healthcareprovider/v1.0/providers';
  public static GET_BENEFICIARY_ADDRESS_DETAILS = 'beneficiary/api/beneficiary/v1.0';
  public static GET_PAYER = 'payer/api/payers/v1.0';
  


  public static USER_SETTING = {

    Listing: "user",
    Delete: "user",
    Add: "user",
    Edit: "user",
    lock: "user/lock",
  };

  public static ROLES_SETTING = {
    Listing: "role",
    Delete: "role",
    Add: "role",
    Edit: "role",
    ScreenPermissions : "role/screenpermissions"
  }

  public static CLIENT_SETTING = {

    Listing: "client",
    Delete: "client",
    Add: "client",
    Edit: "client",
    Check : "client/code/check"
  };

  public static SYSCODE_SETTING = {
    Listing: "syscode/list",
    Delete: "syscode",
    Add: "syscode",
    Edit: "syscode"
  };
  public static CURRENCY_SETTING = {
    Listing: "currency"
  };

  public static TRANSACTION_SETTING = {
    Listing: "transaction",
    Delete: "transaction",
    Add: "transaction",
    Edit: "transaction",
    AllBalance: "transaction/allclientbalances",
    StatementOfAccount: "transaction/statementofaccount",
    GetTransactionTypes: "transaction/types"
  };

}
